import { IEventBus } from "../typings/event-bus";
import { IExceptionInfo } from "../typings/exception";
import { EventBus } from "./event-bus";

export class Exception {
    private static _instance: Exception;
    private readonly eventBus: IEventBus;
    private readonly scope: Element;

    private constructor() {
        this.scope = document.querySelector('.scope-dlp');

        if (!this.scope) {
            return;
        }
        
        this.eventBus = EventBus.instance;
        this.bindEvents();
    }

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    private bindEvents(): void {
        const exceptionIcon: Element = this.scope.querySelector('.debuginfo.dlp');
        if (exceptionIcon) {
            exceptionIcon.addEventListener('click', (event) => {
                this.toggleExceptionDetail(event);
            });
            
            document.addEventListener("DOMContentLoaded", () => {
                this.eventBus.subscribe("DebugError", () => {
                    this.handleError.bind(this);
                });
                
                this.showExceptionIcon();
            });
        }
    }

    private toggleExceptionDetail(eventContext): void {
        const exceptionsDetailContainer: Element = this.scope.querySelector('.exception-details');
        if (exceptionsDetailContainer) {
            exceptionsDetailContainer.classList.toggle('dlp-show-exception-detail');
        }
    }

    private handleError(eventContext, eventData:IExceptionInfo): void {
        let exceptionDetail: Element = this.scope.querySelector('.exception-details');
        if (!exceptionDetail) {
            this.scope.insertAdjacentHTML('afterbegin', '<div class="exception-details"><div class="simplebar"/></div>');
            exceptionDetail = this.scope.querySelector('.exception-details');
        }

        const exceptionSimpleBar: Element = exceptionDetail.querySelector('.simplebar');
        const errorTitle: string = '<div class="title docKey">' + eventData.message + '</div>';
        let errorDetail: string = "";
        if (eventData.details) {
            errorDetail = '<pre>' + eventData.details + '</pre>';
        }
        let errorDetailString: string = '<div class="exception-container">' + errorTitle + errorDetail + '</div>';
        exceptionSimpleBar.insertAdjacentHTML('beforeend', errorDetailString);
        this.showExceptionIcon();
    }

    private showExceptionIcon(): void {
        const exceptionIcon: Element = this.scope.querySelector('.debuginfo.dlp');
        if (exceptionIcon) {
            const exceptionContainer: Element = this.scope.querySelector('.exception-container');

            if (exceptionContainer) {
                exceptionIcon.classList.remove('dlp-hide-debuginfo');
            }
        }
    }
}

Exception.instance;
